import { jsx as _jsx } from "react/jsx-runtime";
const SvgGoldAdvantage = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M1.40625 11.25L5.625 7.03124L8.31625 9.72312C9.09421 8.18924 10.3777 6.97085 11.95 6.27374L13.6625 5.51124M13.6625 5.51124L9.95 4.08624M13.6625 5.51124L12.2375 9.22437",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})
});
export default SvgGoldAdvantage;
